import { render } from "./ManagerBoards.vue?vue&type=template&id=73cbfd3a&scoped=true"
import script from "./ManagerBoards.vue?vue&type=script&lang=js"
export * from "./ManagerBoards.vue?vue&type=script&lang=js"

import "./ManagerBoards.vue?vue&type=style&index=0&id=73cbfd3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cbfd3a"]])

export default __exports__